
/**
 * 플랫폼 지원
 */
export type CreateCourseDraft201LocalizedSectionsItemLecturesItemPlatformSupport = typeof CreateCourseDraft201LocalizedSectionsItemLecturesItemPlatformSupport[keyof typeof CreateCourseDraft201LocalizedSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201LocalizedSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
